import axios from 'axios';
import { BEPI_API } from '../../../shared/config/bepiApiPaths';

// Backend resource path is @Path("web/workshop/quotations/..."), mounted under servlet /web/*
const BASE_URL = BEPI_API.workshop;

export const WorkshopQuotationsApi = {
  // Buscar cotações do cliente
  getClientQuotations: (clientId) => axios.get(`${BASE_URL}/quotations/client/${clientId}`),
  
  // Buscar detalhes do cliente
  getClientDetails: (_clientId) => Promise.reject(
    // TODO: INEXISTENTE no backend: /web/workshop/companies/{id}
    new Error('Endpoint de detalhes do cliente indisponivel no backend atual.')
  ),
  
  // Buscar todas as cotações do usuário
  getUserQuotations: () => axios.get(`${BASE_URL}/quotations`),
  
  // Criar nova cotação/orçamento (Legado)
  createQuotation: (quotationData) => axios.post(`${BASE_URL}/quotations`, quotationData),

  // Criar cotação (via Workshop Flow - permite database específico)
  createQuotationFromWorkshop: (data) => axios.post(`${BASE_URL}/quotations/from-workshop`, data),
  
  // Buscar cotações por status
  getQuotationsByStatus: (status) => axios.get(`${BASE_URL}/quotations/status/${status}`),
  
  // Assumir cotação (Workshop)
  assumeQuotation: (payload) => axios.post(`${BASE_URL}/quotations/assume`, payload),

  unassignQuotation: (payload) => axios.post(`${BASE_URL}/quotations/unassign`, payload),

  // Clientes vinculados ao prestador (Workshop)
  getLinkedClients: () => axios.get(`${BASE_URL}/quotations/clients/linked`),
  linkClient: (payload) => axios.post(`${BASE_URL}/quotations/clients/link`, payload)
};
